import { render } from "./HomeScreen.vue?vue&type=template&id=674ba4c3"
import script from "./HomeScreen.vue?vue&type=script&lang=js"
export * from "./HomeScreen.vue?vue&type=script&lang=js"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__